<template>
  <div>
    <button class="btn btn-cart" data-bs-toggle="modal" data-bs-target="#cartModal">
      <img src="icon-cart.svg" class="cart-icon" alt="Cart Icon">
      <span>Warenkorb<small v-if="cartEntries.length > 0"><br>{{ cart.currency }} {{ cart.totalPriceFormatted }}</small></span>
      <div class="badge" v-if="cartEntries.length > 0">{{ cartEntries.length }}</div>
    </button>

    <div class="modal fade" id="cartModal" tabindex="-1" aria-labelledby="cartModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="cartModalLabel">Warenkorb</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <table class="table" v-if="cartEntries.length > 0">
              <tbody>
                <tr v-for="cartEntry in cartEntries" v-bind:key="cartEntry.event.id">
                  <th>{{ cartEntry.event.name }}<br></th>
                  <td>{{ cartEntry.ticket.shopname }}</td>
                  <td class="text-end">{{ cartEntry|formatPrice }}</td>
                  <td class="text-end"><button class="cart__item-clear" @click="removeCartEntry(cartEntry)"></button></td>
                </tr>
                <tr class="sum-tr">
                  <td colspan="2"><small class="text-muted">Gesamtsumme</small></td>
                  <td class="text-end">{{ cart.currency }} {{ cart.totalPriceFormatted }}</td>
                  <td></td>
                </tr>
                <tr v-for="vatrate in cart.vatrates" v-bind:key="vatrate.vat" class="sum-tr">
                  <td colspan="2"><small class="text-muted">Inkl. {{ vatrate.vat }}% MwSt.</small></td>
                  <td class="text-end"><small class="text-muted">{{ cart.currency }} {{ vatrate.sumFormatted }}</small></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <p v-else>
              Ihr Warenkorb ist zur Zeit leer. Bitte fügen Sie Tickets hinzu, um fortzufahren.
            </p>
          </div>
          <div class="modal-footer">
            <div class="d-grid gap-2 w-100">
              <div class="alert alert-info" v-if="!cart_ok && requiredTickets">Bitte wählen Sie für ein {{ requiredTickets }}er Wahlabo exakt {{ requiredTickets }} Tickets.</div>
              <button type="button" class="btn btn-dark" :disabled="!cart_ok" @click="checkout()">weiter zur kasse</button>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
var bootstrap = require('bootstrap');

// eslint-disable-next-line no-undef
var _cart = cart;

export default {
  name: "Cart",
  data: function () {
    return {
      cart: _cart
    }
  },
  computed: {
    requiredTickets: function () {
      if(this.cart.cartEntries.length > 0) {
        if (this.cart.cartEntries[0].ticket.shopname === "3er Wahlabo") {
          return 3
        } else if (this.cart.cartEntries[0].ticket.shopname === "5er Wahlabo") {
          return 5
        }
      }
      return false;
    },
    cart_ok: function () {
      if(this.requiredTickets) {
        return this.cart.cartEntries.length == this.requiredTickets;
      }
      return false;
    },
    cartEntries: function () {
      return this.cart.cartEntries;
    }
  },
  methods: {
    removeCartEntry: function (cartEntry) {
      this.cart.removeCartEntry(cartEntry);
    },
    checkout: function () {
      this.cart.checkout();
      var modal = new bootstrap.Modal(document.getElementById('cartModal'));
      modal.hide();
    }
  },
  filters: {
    formatPrice: function (cartEntry) {
      console.log(cartEntry);
      // eslint-disable-next-line no-undef
      return cart.assertCurrency() + ' ' + cart.formatCurrency(cartEntry.grossprice);
    }
  }
}
</script>

<style scoped>
.btn-cart {
  position: fixed;
  right: 50%;
  -webkit-transform: translateX(50%);
  transform: translateX(50%);
  bottom: 80px;
  -webkit-box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.16);
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.16);
  z-index: 999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(to top right, #5C5C5C, #A7A7A7 99%);
  border: none;
  color: #ffffff;
  border-radius: 50px;
  height: 50px;
  text-transform: uppercase;
  min-width: 180px;
}
.btn-cart .badge {
  display: inline-block;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  background-image: -webkit-gradient(linear, left bottom, right top, from(#F02020), color-stop(90%, #FB8F8F), color-stop(99%, #FFB7B7));
  background-image: linear-gradient(to top right, #F02020, #FB8F8F 90%, #FFB7B7 99%);
  -webkit-transition: 0.5s all;
  transition: 0.5s all;
  text-align: center;
  padding: 7px;
  font-size: 0.80556rem;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30px;
  flex: 0 0 30px;
  margin-left: 15px;
}

.cart__item-clear {
  width: 32px;
  height: 32px;
  vertical-align: top;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(https://ticketorganizer.eu/cms/res/layouts/ticketorganizer/misc/img/icon-clear.svg);
  border: 0;
  background-color: #fff;
}

.sum-tr {
  border-color: transparent;
}
</style>